module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"de":{"Sync setup":"Synchronisation einrichten","You are now setting up data synchronisation with the selected account.":"Du aktivierst jetzt die Synchronisation mit dem gewählten Account.","Keep my existing local data and sync it.":"Bestehende Daten behalten und dorthin synchronisieren.","OK, start syncing":"OK, Synchronisation starten","Cancel":"Abbrechen"}}')
  delete Component.options._Ctor
}
